//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            itemOptions: {
                width: 185,
                height: 105
            },
            items: [{
                dropAreaIndex: -1,
                correct: true,
                image: `/images/game/w4d3/game_bubble_1_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                correct: false,
                image: `/images/game/w4d3/game_bubble_2_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                correct: true,
                image: `/images/game/w4d3/game_bubble_3_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                correct: false,
                image: `/images/game/w4d3/game_bubble_4_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                correct: true,
                image: `/images/game/w4d3/game_bubble_5_${this.$lang.locale}.png`,
            }, {
                dropAreaIndex: -1,
                correct: true,
                image: `/images/game/w4d3/game_bubble_6_${this.$lang.locale}.png`,
            }],
            dropAreas: [
                {
                    xMin: 731,
                    xMax: 916,
                    yMin: 155,
                    yMax: 260
                },
                {
                    xMin: 664,
                    xMax: 849,
                    yMin: 291,
                    yMax: 396
                },
                {
                    xMin: 878,
                    xMax: 1063,
                    yMin: 272,
                    yMax: 377
                },
                {
                    xMin: 866,
                    xMax: 1051,
                    yMin: 405,
                    yMax: 510
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.items.filter(item => item.dropAreaIndex !== -1 && item.correct).length;
            let numWrong = this.items.filter(item => item.correct).length - numCorrect;

            return this.$game.getDragDropResult(numCorrect, numWrong);
        }
    },

    created () {
        _.shuffle(this.items).forEach((item, index) => {
            let x = 50 + (index % 3 * 200);
            let y = 480 + (Math.floor(index / 3) * 120);

            this.$set(item, 'x', x);
            this.$set(item, 'xInitial', x);

            this.$set(item, 'y', y);
            this.$set(item, 'yInitial', y);

            this.$set(item, 'zIndex', 3);
        });
    },

    methods: {
        dragend (item, { x, y }) {
            item.zIndex--;
            item.x = x;
            item.y = y;

            let dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                x >= area.xMin - this.itemOptions.width / 2 &&
                x <= area.xMax - this.itemOptions.width / 2 &&
                y >= area.yMin - this.itemOptions.height / 2 &&
                y <= area.yMax
            );

            this.$nextTick(() => {
                if (dropAreaIndex === -1) {
                    item.dropAreaIndex = -1;
                    item.x = item.xInitial;
                    item.y = item.yInitial;
                } else {
                    let dropAreaItem = this.items.find(item => item.dropAreaIndex === dropAreaIndex);

                    item.dropAreaIndex = dropAreaIndex;
                    item.x = this.dropAreas[dropAreaIndex].xMin;
                    item.y = this.dropAreas[dropAreaIndex].yMin;

                    if (dropAreaItem !== undefined) {
                        dropAreaItem.dropAreaIndex = -1;
                        dropAreaItem.x = dropAreaItem.xInitial;
                        dropAreaItem.y = dropAreaItem.yInitial;
                    }
                }
            });
        }
    }
};
